<template>
    <div>
        <app-gridview
            v-bind:parentData="{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
                isDelete: true,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{ data: this.errMsg, isErr: this.isErr }"
                v-on:closeError="isErr = $event"
            />
        </div>

        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                    pageTitleValue: this.confirmCode,
                    isConfirm: this.isConfirm,
                }"
                v-on:confirm="confirmDeleteHandler($event)"
                v-on:cancelConfirm="isConfirm = false"
            />
        </div>
    </div>
</template>

<script>
import moment from 'moment';

import GridView      from '../../../components/common/GridView';
import ErrorDialog   from '../../../components/common/ErrorDialog';
import ConfirmDialog from '../../../components/common/ConfirmDialog';

export default {
    components: {
        'app-gridview': GridView,
        'app-error':    ErrorDialog,
        'app-confirm':  ConfirmDialog,
    },

    data() {
        return {
            pageTitle: this.$t('setupposition.positionlist'),
            dataHeader: [
                { text: this.$t('columns.actions'),                 value: 'action',       sortable: false, width: '50px'  },
                { text: this.$t('columns.position'),                value: 'poscode',       width: '120px' },
                { text: this.$t('columns.description'),             value: 'posdesc',       width: '220px' },
                { text: this.$t('setupposition.effectivestartdate'), value: 'startdate',     width: '160px' },
                { text: this.$t('setupposition.effectiveenddate'),  value: 'enddate',       width: '150px' },
                { text: this.$t('setupposition.count'),             value: 'positioncount',         width: '80px'  },
                { text: this.$t('setupposition.countassigned'),     value: 'countassigned', width: '130px' },
                { text: this.$t('columns.disable'),                 value: 'isdisable',     width: '100px' },
                { text: this.$t('columns.remark'),                  value: 'remark',        width: '150px' },
                { text: this.$t('setupposition.reportingposition'), value: 'repposdesc',    width: '180px' },
            ],
            // Each row is one positionsd (detail) record. id = detail PK; positionid = parent header PK.
            dataItems: [],
            loading: false,
            errMsg: '',
            isErr: false,
            isConfirm: false,
            confirmCode: '',
            pendingDelete: null,
            search: this.$route.params.search,
        };
    },

    methods: {
        getPositionListHandler() {
            const vm = this;
            this.loading = true;

            this.$store.dispatch('get', { url: '/position/all' })
                .then(res => {
                    vm.dataItems = res.data.rec;

                    vm.dataItems.forEach(item => {
                        if (item.startdate) item.startdate = moment(item.startdate).format('YYYY-MM-DD');
                        if (item.enddate)   item.enddate   = moment(item.enddate).format('YYYY-MM-DD');
                    });

                    vm.loading = false;
                })
                .catch(err => {
                    vm.isErr  = true;
                    vm.errMsg = err;
                    vm.loading = false;
                });
        },

        editItemHandler(event) {
            // GridView emits { id: item.id, search }. item.id = detail (child) id.
            // positionid on the row is the parent/header id.
            const row = this.dataItems.find(r => r.id === event.id);

            this.$router.push({
                name:   'positionedit',
                params: { id: row ? row.positionid : event.id, search: event.search },
                query:  { detailid: event.id },
            });
        },

        newRecordHandler() {
            this.$router.push({ name: 'positionnew' });
        },

        deleteItemHandler(item) {
            // `item` is the full row object emitted by GridView's onDeleteItem.
            // Delete the individual child detail record (not the whole parent).
            this.confirmCode  = (item.poscode || '') + (item.startdate ? ' [' + item.startdate + ']' : '');
            this.pendingDelete = item;
            this.isConfirm    = true;
        },

        confirmDeleteHandler($event) {
            this.isConfirm = false;
            if (!$event || !this.pendingDelete) { this.pendingDelete = null; return; }

            const item   = this.pendingDelete;
            const userid = this.$store.getters.userId;
            this.pendingDelete = null;

            // item.id is the detail (child) id — delete that specific detail record.
            const url = `/position/detail/${item.id}/${userid}`;

            this.$store.dispatch('delete', { url })
                .then(res => {
                    if (res.data.error) {
                        this.isErr  = true;
                        this.errMsg = res.data.error;
                    } else {
                        this.getPositionListHandler();
                    }
                })
                .catch(err => {
                    this.isErr  = true;
                    this.errMsg = err;
                });
        },
    },

    mounted() {
        this.getPositionListHandler();
    },
};
</script>
